import { Component, HostListener, Input, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-image-slider',
  templateUrl: './image-slider.component.html',
  styleUrls: ['./image-slider.component.scss'],
  animations: [
    trigger('carouselAnimation', [
      transition('void => *', [
        style({opacity: 0}),
        animate('300ms', style({opacity: 1}))
      ]),
      transition('* => void', [
        animate('300ms', style({opacity: 0}))
      ])
    ])
  ]
})
export class ImageSliderComponent implements OnInit {

  @Input() images;
  @Input() index = 0;
  @Input() numberOfBottomImages = 3;
  imagesIndexOffset = 0;
  animationDone = true;
  innerWidth;
  mobileMaxWidth = 960;
  selectedImageIndex = 0;
  currentImagesPage = 1;

  constructor() {
  }

  ngOnInit(): void {
  }

  goNext() {
    if (this.index < this.images.length - 1 && this.animationDone) {

      this.animationDone = false;
      this.index++;
      this.selectedImageIndex++;

    }
    if (this.imagesIndexOffset < this.images.length - this.numberOfBottomImages && this.index % this.numberOfBottomImages === 0) {
      this.imagesIndexOffset += this.numberOfBottomImages;
      this.currentImagesPage++;
    }
  }

  goPrevious() {
    if (this.index > 0 && this.animationDone) {
      if (this.imagesIndexOffset > 0 && this.index % this.numberOfBottomImages === 0) {
        this.imagesIndexOffset -= this.numberOfBottomImages;
        this.currentImagesPage--;
      }
      this.animationDone = false;
      this.index--;
      this.selectedImageIndex--;
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
  }

  isMobileResolution() {
    if (this.innerWidth) {
      return this.innerWidth <= this.mobileMaxWidth;
    } else {
      return window.innerWidth <= this.mobileMaxWidth;
    }
  }

  getBackIcon() {
   return this.isMobileResolution() ? 'west' : 'north';
  }

  getForwardIcon(){
    return this.isMobileResolution() ? 'east' : 'south';
  }
}
